import {
	ADMINADDINTEGRATION_SUCCESS,
	ADMINADDINTEGRATION_FAILED,
	RESET_ADMINADDINTEGRATION,
	LOADING_ADMINADDINTEGRATION,
	NETWORK_ERROR_ADMINADDINTEGRATION
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminAddIntegration = () => {
	return { type: RESET_ADMINADDINTEGRATION };
};

const adminAddIntegration = (userData, authTokenIs) => async (dispatch) => {
	dispatch({ type: LOADING_ADMINADDINTEGRATION });
	await adminServices
		.post("addOrUpdateIntegration", userData, { headers: { AuthToken: authTokenIs } })
		.then((res) => {
			switch (res.data.status) {
				case "success":
					dispatch(adminAddIntegrationsuccess(res.data));
					break;
				default:
					dispatch(adminAddIntegrationFailed(res.data));
					break;
			}
		})
		.catch((err) => {
			dispatch({
				type: NETWORK_ERROR_ADMINADDINTEGRATION,
				payload: err
			});
		});
};
function adminAddIntegrationsuccess(data) {
	return {
		type: ADMINADDINTEGRATION_SUCCESS,
		payload: data
	};
}
function adminAddIntegrationFailed(data) {
	return {
		type: ADMINADDINTEGRATION_FAILED,
		payload: data
	};
}

export { resetAdminAddIntegration, adminAddIntegration };
